export class ConfiguracaoPaginacao {

    paginaAtual: number;
    totalPaginas: number;

}



// WEBPACK FOOTER //
// ./src/app/components/paginacao/configuracaoPaginacao.ts